import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, LayoutDashboard, ShieldCheck } from "lucide-react";
import Logo from "@/components/Logo";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="glass sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="group">
          <Logo size={40} withText className="group-hover:opacity-90 transition-opacity" />
        </Link>

        <nav className="flex items-center gap-2 sm:gap-4">
          {user ? (
            <>
              {user.role === "admin" && (
                <Button
                  variant="ghost"
                  size="sm"
                  data-testid="nav-admin-btn"
                  onClick={() => navigate("/admin")}
                  className="text-zinc-300 hover:text-white"
                >
                  <ShieldCheck className="w-4 h-4 mr-1.5" /> Admin
                </Button>
              )}
              <Button
                variant="ghost"
                size="sm"
                data-testid="nav-dashboard-btn"
                onClick={() => navigate("/dashboard")}
                className="text-zinc-300 hover:text-white"
              >
                <LayoutDashboard className="w-4 h-4 mr-1.5" /> Konto
              </Button>
              <Button
                variant="outline"
                size="sm"
                data-testid="nav-logout-btn"
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                className="rounded-full border-white/15 bg-transparent hover:bg-white/5"
              >
                <LogOut className="w-4 h-4 sm:mr-1.5" />
                <span className="hidden sm:inline">Abmelden</span>
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="ghost"
                size="sm"
                data-testid="nav-login-btn"
                onClick={() => navigate("/login")}
                className="text-zinc-300 hover:text-white"
              >
                Anmelden
              </Button>
              <Button
                size="sm"
                data-testid="nav-book-btn"
                onClick={() => navigate("/register")}
                className="rounded-full bg-primary text-primary-foreground hover:brightness-110"
              >
                Jetzt buchen
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
